import { useState } from 'react';

import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError } from '@/lib/exception';
import { getClient } from '@/lib/restClient';
import { SalesPeriodType } from '@/pages/menu-managements/items/hooks/useMenuManagementItemForm';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import {
  BrandItemDelivery,
  BrandItemEatIn,
  BrandItemTakeout,
} from '@/services/BrandItem';

import { MenuManagementBrandItemService } from '../../MenuManagementItemService';
type Parameters = { associateBrandId: number; masterStoreId: number };

export type PreviewBrandItem = {
  id: string;
  title: Title;
  image_url: string | null;
  memo: string | null;
  description: string | null;
  sales_period_type: SalesPeriodType;
  sales_start_at: string | null;
  sales_end_at: string | null;
  relative_sales_start_at: number | null;
  relative_sales_end_at: number | null;
  limit_of_purchase: number | null;
  takeout: BrandItemTakeout | null;
  delivery: BrandItemDelivery | null;
  eat_in: BrandItemEatIn | null;
  order_methods: OrderMethod[];
  can_serve_alone: boolean;
  is_auth_required: boolean;
  brand_option_group_sort_objects: SearchItem[];
  updated_at: string;
  uber_menu_item_id: string | null;
};
export type PreviewBrandCategory = {
  id: string;
  title: Title;
  uber_category_id: string | null;
};
export type PreviewBrandOptionGroup = {
  id: string;
  title: Title;
  quantity_min: number;
  qauntity_max: number | null;
  uber_modifier_group_id: string | null;
  uber_modifier_option_item_ids: string[] | null;
};
export type UberPreviewBulkUpsertBrandItemsResponse = {
  brand_items: PreviewBrandItem[];
  brand_categories: PreviewBrandCategory[];
  brand_option_groups: PreviewBrandOptionGroup[];
  uber_category_ids_by_uber_menu_item_id: {
    [uber_menu_item_id: string]: string[];
  };
  uber_modifier_group_ids_by_uber_menu_item_id: {
    [uber_menu_item_id: string]: string[];
  };
  errors_by_line: { [line: string]: string[] };
  insert_count: number;
  update_count: number;
};
const useMenuManagementUberPreviewBulkUpsertBrandItems = (): {
  loading: boolean;
  preview: (
    params: Parameters
  ) => Promise<UberPreviewBulkUpsertBrandItemsResponse | undefined>;
} => {
  const [loading, setLoading] = useState(false);
  const preview = async (params: Parameters) => {
    try {
      setLoading(true);
      const menuManagementBrandItemService = new MenuManagementBrandItemService(
        getClient()
      );
      return await menuManagementBrandItemService.previewUberEatsImport(params);
    } catch (error) {
      // NOTE: クライアントエラーの場合は返ってきたエラーメッセージを表示する
      if (error instanceof HttpError && error.status < 500) {
        errorHandler({
          error,
          alertMessage:
            error.message ||
            'メニューの取り込みができませんでした。店舗管理ページを確認してください。',
        });
      } else {
        errorHandler({ error: error as Error });
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    preview,
  };
};

export default useMenuManagementUberPreviewBulkUpsertBrandItems;
